"use strict";

(function() {

let startersLoanOffered = true; // Set this based on the choosen municipality
let isSelectionMade = false; // has a municipality been choosen from the list?
let currentSuggestionIndex = -1;
let currentStep;

// TODO: non-js version
// - either static page with all questions with link/info about next step, and after q10 list of
// municipalities with starter loan and following questions
// - or dynamic postback and with serverside rendered pages

function showStep() {
	// show active page and hide all others
	// called from root, popstate event handler, link onclick event handlers
	const step = history.state ?? 0;
	console.log("showStep",step);

	document.querySelectorAll(".step:not([hidden])").forEach(s => s.setAttribute("hidden",""));
	document.querySelectorAll(".step")[step].removeAttribute("hidden");
	currentStep = step;
}

window.addEventListener("popstate", event => {
	console.log("pop",history)
	showStep(event.state);
})

document.querySelector('#noscript').setAttribute("hidden","");
document.querySelector('#startbutton').removeAttribute("hidden");
showStep();
console.log("load",history)

document.querySelectorAll("a[href='" + window.location.pathname + "']").forEach(a => a.href="#step-0");
document.querySelectorAll("a[href^='#step']").forEach(a => a.addEventListener("click", evt => {
	evt.preventDefault();
	history.pushState(evt.target.closest('a').hash.split("-")[1],"");
	console.log("push",history)
	showStep();
}))

// === municipality selector ===

function selectMunicipality(municipality) {
	// sets the input field to the name selected from the list, hides list, shows next button and optional info
	// called from filterMunicipalities, #municipalityInput.keydown
	console.log("selectMunicipality",municipality)
	const input = document.getElementById("municipalityInput");
	input.value = municipality;
	document.getElementById("suggestions").setAttribute("hidden","");
	input.setAttribute("aria-expanded", "false");
	isSelectionMade = true;
	document.getElementById("loanOfferMunicipality").innerText = municipality;

	document.querySelector("a[href='#step-2']").removeAttribute("hidden");
	startersLoanOffered = municipalitiesStarters.includes(municipality); // NB: this value is used in Q11 also!
	const startersInfo = document.querySelector("#step-1 .info");
	const startersLink = document.querySelector("a[data-step='11']");
	if (startersLoanOffered) {
		startersInfo.setAttribute("hidden","");
		startersLink.href = startersLink.dataset.starters;
	} else {
		startersInfo.removeAttribute("hidden");
		startersLink.href = startersLink.dataset.org;
	}
}

function highlightSuggestion(index) {
	// set a class on the suggestion item that is selected by keyboard movement
	// called from filterMunicipalities, #municipalityInput.keydown (3x)
	document.querySelectorAll(".suggestion-item").forEach((suggestion, i) => {
		if (i === index) {
			suggestion.classList.add("highlighted");
			suggestion.scrollIntoView({ block: "nearest" });
			document.getElementById("municipalityInput").setAttribute("aria-activedescendant", suggestion.id);
		} else {
			suggestion.classList.remove("highlighted");
		}
	});
}

function filterMunicipalities() {
	// recreate or remove autocomplete list of municipalities
	// triggered by #municipality.keydown (conditionally), #municipalityInput.input
	const input = document.getElementById("municipalityInput");
	const suggestionsContainer = document.getElementById("suggestions");

	suggestionsContainer.innerHTML = "";
	currentSuggestionIndex = -1;
	input.setAttribute("aria-expanded", "false");
	if (typeof municipalities === "undefined") {
		console.error("The 'municipalities' variable is not defined.");
		return;
	}
	const filteredMunicipalities = input.value.length === 0
		? municipalities
		: municipalities.filter(municipality =>
			municipality.toLowerCase().includes(input.value.toLowerCase())
		);

	if (filteredMunicipalities.length > 0) {
		filteredMunicipalities.forEach((municipality, index) => {
			const div = document.createElement("div");
			div.classList.add("suggestion-item");
			div.setAttribute("role", "option"); // Set role to option
			div.innerText = municipality;
			div.onclick = () => selectMunicipality(municipality);
			div.onmouseover = () => highlightSuggestion(index);
			suggestionsContainer.appendChild(div);
		});
		suggestionsContainer.removeAttribute("hidden");
		input.setAttribute("aria-expanded", "true");
	} else {
		suggestionsContainer.setAttribute("hidden","");
	}
}

document.getElementById("municipalityInput").addEventListener("focus", () => {
	filterMunicipalities(); // create and show list of municipalities
	document.getElementById("suggestions").removeAttribute("hidden");
	document.getElementById("municipalityInput").setAttribute("aria-expanded", "true");
})
// BUG: can't hide list on blur, otherwise can't use mouse to select an item!
// document.getElementById("municipalityInput").addEventListener("blur", () => {
//     document.getElementById("suggestions").setAttribute("hidden","");
// })

document.getElementById("municipalityInput").addEventListener("keydown", function (event) {
	// triggered on any key press (incl cursor keys and tab key)
	const suggestions = document.querySelectorAll(".suggestion-item");

	if (event.key === "ArrowDown") {
		if (suggestions.length > 0) {
			// If there are suggestions, navigate through them
			currentSuggestionIndex = (currentSuggestionIndex + 1) % suggestions.length;
			highlightSuggestion(currentSuggestionIndex);
		} else {
			// If input is empty, show all municipalities
			filterMunicipalities(); // recreate or remove autocomplete list of municipalities
			currentSuggestionIndex = 0;
			highlightSuggestion(currentSuggestionIndex);
		}
		event.preventDefault();
	} else if (event.key === "ArrowUp") {
		if (suggestions.length > 0) {
			currentSuggestionIndex = (currentSuggestionIndex - 1 + suggestions.length) % suggestions.length;
			highlightSuggestion(currentSuggestionIndex);
		}
		event.preventDefault();
	} else if (event.key === "Enter") {
		if (currentSuggestionIndex >= 0 && currentSuggestionIndex < suggestions.length) {
			selectMunicipality(municipalities.find(m => m === suggestions[currentSuggestionIndex].innerText));
		}
		event.preventDefault();
	} else if (event.key === "Escape") {
		document.getElementById("suggestions").setAttribute("hidden","");
		document.getElementById("municipalityInput").setAttribute("aria-expanded", "false");
	}
});

document.getElementById("municipalityInput").addEventListener("input", function () {
	// triggered when contents of input field changes (triggered after keydown)

	isSelectionMade = false; // will hide "next" button
	filterMunicipalities(); // recreate or remove autocomplete list of municipalities
	document.querySelector("a[href='#step-2']").setAttribute("hidden",""); // hide next button // BUG: very bad UX to hide form elements
	document.querySelector("#step-1 .info").setAttribute("hidden",""); // hide infobox
});

})();
